import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const StyledScrollToTop = styled.div`
position: fixed;
bottom: 2rem;
right: 2rem;
cursor: pointer;
opacity: ${(props) => (props.isVisible ? 1 : 0)};
color: white;
transition: opacity .5s;
z-index: 200;
`;

const StyledArrow = styled.svg`
width: 3rem;
opacity: 0.6;
fill: #FFFFFF;

&:hover {
opacity: 1;
}
`;

export const scrollToTop = (isSmooth = false) => () => {
  try {
    // trying to use new API
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: isSmooth ? 'smooth' : 'auto',
    });
  } catch (error) {
    // just a fallback for older browsers
    window.scrollTo(0, 0);
  }
};

function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const scrollHandler = () => setIsVisible(window.pageYOffset > 500);
  useEffect(() => {
    document.addEventListener('scroll', scrollHandler);
    return () => {
      document.removeEventListener('scroll', scrollHandler);
    };
  }, []);

  return (
    <StyledScrollToTop
      onClick={scrollToTop(true)}
      isVisible={isVisible}
    >
      <StyledArrow version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enableBackground="new 0 0 1000 1000" xmlSpace="preserve">
        <g><path d="M500,990C229.4,990,10,770.6,10,500C10,229.4,229.4,10,500,10c270.6,0,490,219.4,490,490C990,770.6,770.6,990,500,990L500,990z M500,919.2c231.5,0,419.2-187.7,419.2-419.2S731.5,80.8,500,80.8C268.5,80.8,80.8,268.5,80.8,500S268.5,919.2,500,919.2L500,919.2z M500,222.5l107.2,137.8L714.4,500H574.7v277.5H425.4V500H285.6l107.2-139.7L500,222.5L500,222.5z" /></g>
      </StyledArrow>
    </StyledScrollToTop>
  );
}

export default ScrollToTop;
